import Api from '@/apis/businessApi'
import Store from '@/store'
import i18n from '@/i18n'

export default {
  async getUser () {
    return Api()
      .get('/v1/userProfile')
      .then(async function (response) {
        return { success: true, value: response.data }
      })
      .catch(async function (error) {
        await Store.dispatch('SetSnackBarMessage', {
          message: i18n.t('Services.UserProfile.Messages.GetUserErrorMessage'),
          color: 'error',
        })
        console.error(error)
        return { success: false }
      })
  },
  async saveUser (user) {
    var updatedUser = {
      uid: user.uid,
      firstName: user.firstName,
      lastName: user.lastName,
      email: user.email,
    }

    return Api()
      .put('/v1/userProfile', updatedUser)
      .then(function (response) {
        Store.dispatch('SetSnackBarMessage', {
          message: i18n.t('Services.UserProfile.Messages.SaveUserSuccessMessage', [updatedUser.firstName, updatedUser.lastName]),
          color: 'success',
        })
        return { success: true, value: updatedUser }
      })
      .catch(function (error) {
        if (error.response.status === 400) {
          return { success: false, badRequestReasons: error.response.data }
        }
        Store.dispatch('SetSnackBarMessage', {
          message: i18n.t('Services.UserProfile.Messages.SaveUserErrorMessage', [updatedUser.firstName, updatedUser.lastName]),
          color: 'error',
        })
        console.log(error) // todo what to do?
        return { success: false }
      })
  },
  async ChangePassword (oldPassword, newPassword, confirmPassword) {
    var model = {
      oldPassword: oldPassword,
      newPassword: newPassword,
      confirmPassword: confirmPassword,
    }
    return Api()
      .post('/v1/userProfile/password', model)
      .then(async function (response) {
        return { success: true }
      })
      .catch(async function (error) {
        if (error.response.status === 400) {
          return { success: false, badRequestReasons: error.response.data }
        }

        await Store.dispatch('SetSnackBarMessage', {
          message: i18n.t('Services.UserProfile.Messages.ChangePasswordErrorMessage'),
          color: 'error',
        })
        console.error(error)
        return { success: false }
      })
  },
}
